import { storeActionTypes } from "../actions/stores.actions";
export default function storesReducer(state = null, action) {
    switch (action.type) {
        case storeActionTypes.GET_STORE_DETAILS:
            return { storeId: action.data };
        default:
            return state;
    }

};